export const GeoTypes = {
  POINT      : 'Point',
  LINE_STRING: 'LineString',
  POLYGON    : 'Polygon',
}